// extracted by css-extract-rspack-plugin
export default {"CopilotLogoSuite":"CopilotLogoSuite-module__CopilotLogoSuite__tnNCz"};